/* VELOURÉA — lifestyle videos on product cards (custom.card_media): load and play only while on screen. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target: v, isIntersecting }) => {
      if (isIntersecting) {
        v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); v.load(); });
        if (!reduce.matches) v.play().catch(() => {});
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '150px 0px', threshold: 0.25 });
  const watch = (root) => root.querySelectorAll('video[data-card-video]:not([data-watched])').forEach((v) => { v.dataset.watched = ''; io.observe(v); });
  watch(document);
  new MutationObserver((list) => {
    for (const m of list) for (const n of m.addedNodes) if (n.nodeType === 1) watch(n);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
